import OrderHistoryTable from "./OrderHistoryTable";

export default OrderHistoryTable;
